import api from './api'

// ── Helper — convert filter state to API query params ─────────────────────────
function buildParams(filters = {}) {
  const p = {}
  if (filters.dateRange && filters.dateRange !== 'custom') p.date_range = filters.dateRange
  if (filters.merchant)  p.merchant_id = filters.merchant
  if (filters.channel)   p.channel     = filters.channel
  if (filters.status)    p.status      = filters.status
  return p
}

const dashboardService = {
  // ── BUG 1 FIX: pass filters as query params on every call ──────────────────
  getKpis: (filters = {}) =>
    api.get('/api/v1/dashboard/kpis', { params: buildParams(filters) }).then(r => r.data),

  getHourlyVolume: (filters = {}) =>
    api.get('/api/v1/reports/hourly-volume', { params: buildParams(filters) }).then(r => r.data),

  getApprovalBlockTrend: (filters = {}) =>
    api.get('/api/v1/reports/approval-block-trend', { params: buildParams(filters) }).then(r => r.data),

  getAlertTrend: (filters = {}) =>
    api.get('/api/v1/reports/alert-trend', { params: buildParams(filters) }).then(r => r.data),

  // ── BUG 2 FIX: pass filters to latency so backend can filter by date_range ─
  getTopRules: (filters = {}) =>
    api.get('/api/v1/dashboard/top-rules', { params: buildParams(filters) }).then(r => r.data),

  getTopRiskyMerchants: (filters = {}) =>
    api.get('/api/v1/dashboard/risky-merchants', { params: buildParams(filters) }).then(r => r.data),

  getRecentFlagged: (filters = {}) =>
    api.get('/api/v1/dashboard/recent-flagged', { params: buildParams(filters) }).then(r => r.data),

  getLatencyHealth: (filters = {}) =>
    api.get('/api/v1/dashboard/latency-health', { params: buildParams(filters) }).then(r => r.data),
}

export default dashboardService
